export interface RegisterDefaultParameterInterLibraryLoanRequest {
  configBranchCode: string
  materialFormatCode: string
  holdingBranchCode: string
  collectionType: string
  interlibraryLoanCode: string
  borrowingDate: string
  borrowingPeriod: string
  allBranchFlag: boolean
}

export function RegisterDefaultParameterInterLibraryLoanRequestToJSON(
  value: RegisterDefaultParameterInterLibraryLoanRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined,
    material_format_code:
      value.materialFormatCode !== '' ? value.materialFormatCode : undefined,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== ''
        ? value.interlibraryLoanCode
        : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_period:
      value.borrowingPeriod !== '' ? value.borrowingPeriod : undefined,
    all_branch_flag: value.allBranchFlag ?? undefined
  }
}
